import { createRoute } from '@tanstack/react-router';
import { KalendarPage } from '@/modules/kalendar/KalendarPage';
import { parseKalendarSearch } from '@/modules/kalendar/helpers';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/kalendar',
  component: KalendarPage,
  validateSearch: parseKalendarSearch,
});
